import { api } from '@/lib/api';

export const consultationsService = {
  async getByAppointment(appointmentId) {
    const { data } = await api.get(
      `/consultations/by-appointment/${appointmentId}`
    );
    return { data };
  },

  async create(payload) {
    const { data } = await api.post('/consultations', payload);
    return { data };
  },

  async update(id, payload) {
    const { data } = await api.patch(`/consultations/${id}`, payload);
    return { data };
  },
};
